import axios from 'axios';

const NAVER_DOMAIN = /^http(s)?:\/\/.*.naver.com/;
const getShortenUrl = async (payOrigin, targetUrl) => {
  const isValidUrl = targetUrl?.match(NAVER_DOMAIN);

  // 네이버 도메인 url 만 shorten url 처리 가능
  if (isValidUrl) {
    const {
      data: {
        code,
        result: {
          shortenUrl
        } = {
          shortenUrl: ''
        }
      }
    } = await axios.post(`${payOrigin}/member/ext-api/shortener/url`, {
      orgUrl: targetUrl
    }, {
      withCredentials: true
    });
    if (code === '00') {
      return shortenUrl;
    } else {
      return targetUrl;
    }
  } else {
    return targetUrl;
  }
};
var getShortenUrl$1 = getShortenUrl;

export { getShortenUrl$1 as default };
